import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class LinkScroll extends Component {
  static defaultProps = {
    offsetTop: 0,
    position: LinkScroll.top
  };

  static propTypes = {
    offsetTop: PropTypes.number,
    to: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    if (this.props.onClick) {
      this.onClick(event);
    }

    if (event.defaultPrevented) {
      return;
    }

    const el = document.querySelector(this.props.to);
    if (!el) {
      console.warn('Cannot found element id', this.props.to);
      return;
    }

    const rect = el.getBoundingClientRect();
    event.preventDefault();
    
    window.scroll({
      top: window.scrollY + rect.y - this.props.offsetTop,
      behavior: 'smooth'
    });
  }

  render() {
    const { position, offsetTop, to, onClick, children, ...props } = this.props;

    return (
      <a href={to} {...props} onClick={this.onClick}>{children}</a>
    );
  }
}